import { Injectable } from '@angular/core';
import { Auth } from '../models/auth';
import { appConfig } from 'src/environments/enviroment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, of } from 'rxjs';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private patientNameSubject = new BehaviorSubject<string>('');
  patientName$ = this.patientNameSubject.asObservable();

  private userDetailsSubject = new BehaviorSubject<any>({}); // Object to store both practiceName and patientName
  userDetails$ = this.userDetailsSubject.asObservable();

  returnUrl: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    protected encryptDecryptService: EncryptDecryptService
  ) {
    this.initializeFromStorage();
    this.checkValidation()
  }




  checkValidation() {
    
    const encryptedData = sessionStorage.getItem('u.');
  
    if (encryptedData !== null) {
      const decryptedData = this.encryptDecryptService.decryptUsingAES256(encryptedData);
      let userDetails = JSON.parse(decryptedData);
  
      if (userDetails.token) {
        const isjwtToken = userDetails.token;
        const decodedToken: any = this.encryptDecryptService.decodeJwtToken(isjwtToken);
        if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
          sessionStorage.clear();
          this.router.navigateByUrl('/login');
          return;
        }
      } else {
        sessionStorage.clear();
      }
    }
  }
  

  setPracticeAndPatientNames(userDetails: any) {
    if (userDetails && userDetails.practiceName && userDetails.patientName) {
      try {
        // Ensure that there are no non-serializable values like functions or undefined
        const sanitizedUserDetails = JSON.parse(JSON.stringify(userDetails));
    
        const encryptPracticeAndPatientName = this.encryptDecryptService.encryptUsingAES256(sanitizedUserDetails);
        sessionStorage.setItem('p&p', encryptPracticeAndPatientName);
        this.userDetailsSubject.next(userDetails);
      } catch (error) {

        console.error('Error encrypting or setting practice and patient names:', error);
      }
    } else {
      console.error('Invalid userDetails object:', userDetails);
    }    
  }

  initializeFromStorage() {
    const storedUserDetails = sessionStorage.getItem('p&p');
    if (storedUserDetails) {
      try {
        const decryptPracticeAndPatientName = this.encryptDecryptService.decryptUsingAES256(storedUserDetails);
        const userDetails = JSON.parse(decryptPracticeAndPatientName);

        if (userDetails && userDetails.practiceName && userDetails.patientName) {
          this.userDetailsSubject.next(userDetails);
        } else {
          console.error('Decrypted user details are invalid:', userDetails);
        }
      } catch (error) {
        console.error('Error decrypting user details from storage:', error);
      }
    }
  }

  isAuthenticated: boolean = false;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  protected apiURL: string = appConfig.apiUrl;

  authenticateUser(ApiUrl: string, auth: Auth) {
    if (!ApiUrl || !auth) {
      console.error('Invalid API URL or auth object:', ApiUrl, auth);
      return of(null);  // Return an observable with null if input is invalid
    }
    return this.http.post(this.apiURL + ApiUrl, auth).pipe(
      catchError(error => {
        // Ensure that the error has the expected structure
        const errorMessage = error?.error?.message || error?.message || 'An unknown error occurred';
        console.error('Error during authentication:', errorMessage);
        return of(errorMessage); // Return an observable with the error message
      })
    );
  }
  

  generateOtp(payLoad: any) {
    if (!payLoad) {
      console.error('Invalid payload for generating OTP:', payLoad);
      return of(null);  // Return an observable with null if input is invalid
    }
    return this.http.post(this.apiURL + 'auth/generate-patient-otp', payLoad).pipe(
      catchError(error => {
        console.error('Error generating OTP:', error);
        return of(null); // Return null observable in case of error
      })
    );
  }

  _practiceInfo(practiceId: number) {
    if (!practiceId) {
      console.error('Invalid practiceId:', practiceId);
      return of(null);  // Return an observable with null if input is invalid
    }
    return this.http.post(this.apiURL + 'general/get-practice-info', practiceId, this.httpOptions).pipe(
      catchError(error => {
        console.error('Error fetching practice info:', error);
        return of(null); // Return null observable in case of error
      })
    );
  }

  _reGenerateJwtToken(encryptedPayload: any) {
    if (!encryptedPayload) {
      console.error('Invalid encrypted payload for token refresh:', encryptedPayload);
      return of(null);  // Return an observable with null if input is invalid
    }
    return this.http.post(this.apiURL + 'auth/refresh-token', encryptedPayload, this.httpOptions).pipe(
      catchError(error => {
        console.error('Error refreshing JWT token:', error);
        return of(null); // Return null observable in case of error
      })
    );
  }

  _logOut() {
    try {
      this.isAuthenticated = false;
      sessionStorage.removeItem('u.');
      sessionStorage.removeItem('p.');
      sessionStorage.removeItem('p&p');
      this.returnUrl = sessionStorage.getItem('returnUrl');
      if (this.returnUrl !== null) {
          const decryptedData = this.encryptDecryptService.decryptUsingAES256(this.returnUrl);
          console.log('decryptedData', decryptedData);
          this.router.navigateByUrl(JSON.parse(decryptedData));
      } else {
        console.error('Return URL is not set. Redirecting to home.');
        this.router.navigateByUrl('/'); // Default to home if no return URL is set
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }
}
